// import React from 'react';
// import { Link } from 'react-router-dom';
// import chessslogo from '../images/chessslogo.png';
// import GameSummary from './GameSummary';
// import { TAGS } from '../util/constants'; // Import TAGS to use the exact keys
// import { getLandingGames } from '../util/api/featuredContent';
// import { fetchGame } from '../util/api/game';

// const LiChessFAQ = () => {
//   return (
//     <div className="" style={{ 
//       display: 'flex', 
//       flexDirection: 'column', 
//       alignItems: 'center',
//       background: "linear-gradient(to top, #3066BE, black)",
//       minHeight: '100vh',
//       width: '100%',
//       margin: 0,
//       padding: '40px 20px',
//       overflow: 'auto',
//       scrollbarWidth: 'thin',
//       scrollbarColor: 'gold transparent',
//     }}>
//       <div style={{
//         maxWidth: '1200px',
//         width: '100%',
//         margin: '0 auto',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//       }}>
//         <img
//           src={chessslogo}
//           alt="ChessClip Logo"
//           style={{ 
//             width: '150px', 
//             marginBottom: '40px',
//             filter: 'drop-shadow(0 0 10px rgba(255, 215, 0, 0.3))'
//           }}
//         />
        
//         {/* Add your FAQ content here */}
//         <div style={{
//           width: '100%',
//           maxWidth: '900px',
//           padding: '20px',
//           color: 'white',
//         }}>
//           {/* FAQ content will go here */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LiChessFAQ;

import React, { useState, useCallback } from 'react';
import { Chess } from 'chess.js';
import { Chessboard } from 'react-chessboard';

const ChessGame = () => {
  // Helper function to extract position part of FEN (excluding move counters)
  const getPositionFromFen = (fen) => {
    const parts = fen.split(' ');
    // Return first 4 parts: pieces, turn, castling, en passant
    // Exclude halfmove and fullmove counters (parts 4 and 5)
    return parts.slice(0, 4).join(' ');
  };

  const [game, setGame] = useState(new Chess());
  const [moveHistory, setMoveHistory] = useState([]);
  const [fenCounts, setFenCounts] = useState({ [getPositionFromFen(new Chess().fen())]: 1 });

  const makeMove = useCallback((sourceSquare, targetSquare) => {
    const gameCopy = new Chess(game.fen());
    
    try {
      // Attempt to make the move
      const move = gameCopy.move({
        from: sourceSquare,
        to: targetSquare,
        promotion: 'q' // Always promote to queen for simplicity
      });

      // If move is legal, update the game state
      if (move) {
        const newFen = gameCopy.fen();
        const positionKey = getPositionFromFen(newFen);
        const san = move.san;
        
        // Update the game
        setGame(gameCopy);
        
        // Add to move history
        const moveNumber = Math.ceil(moveHistory.length / 2) + 1;
        const isWhiteMove = move.color === 'w';
        
        const newMoveEntry = {
          moveNumber,
          san,
          fen: newFen,
          positionKey,
          move: move,
          isWhiteMove
        };
        
        setMoveHistory(prev => [...prev, newMoveEntry]);
        
        // Track position occurrences for threefold repetition (excluding move counters)
        setFenCounts(prev => {
          const newCounts = { ...prev };
          newCounts[positionKey] = (newCounts[positionKey] || 0) + 1;
          
          // Check for threefold repetition
          if (newCounts[positionKey] >= 3) {
            setTimeout(() => {
              alert('Threefold repetition detected! The same position has occurred three times.');
            }, 100);
          }
          
          return newCounts;
        });
        
        return true;
      }
    } catch (error) {
      
    }
    
    return false;
  }, [game, moveHistory]);

  const onDrop = useCallback((sourceSquare, targetSquare) => {
    return makeMove(sourceSquare, targetSquare);
  }, [makeMove]);

  const resetGame = () => {
    const newGame = new Chess();
    setGame(newGame);
    setMoveHistory([]);
    setFenCounts({ [getPositionFromFen(newGame.fen())]: 1 });
  };

  const undoMove = () => {
    const gameCopy = new Chess(game.fen());
    const move = gameCopy.undo();
    
    if (move) {
      setGame(gameCopy);
      setMoveHistory(prev => prev.slice(0, -1));
      
      // Update position counts
      const currentPositionKey = getPositionFromFen(game.fen());
      setFenCounts(prev => {
        const newCounts = { ...prev };
        if (newCounts[currentPositionKey]) {
          newCounts[currentPositionKey]--;
          if (newCounts[currentPositionKey] === 0) {
            delete newCounts[currentPositionKey];
          }
        }
        return newCounts;
      });
    }
  };

  const gameStatus = () => {
    if (game.isCheckmate()) {
      return `Checkmate! ${game.turn() === 'w' ? 'Black' : 'White'} wins.`;
    } else if (game.isDraw()) {
      if (game.isStalemate()) {
        return 'Draw by stalemate.';
      } else if (game.isThreefoldRepetition()) {
        return 'Draw by threefold repetition.';
      } else if (game.isInsufficientMaterial()) {
        return 'Draw by insufficient material.';
      } else {
        return 'Draw by 50-move rule.';
      }
    } else if (game.isCheck()) {
      return `${game.turn() === 'w' ? 'White' : 'Black'} is in check.`;
    }
    return `${game.turn() === 'w' ? 'White' : 'Black'} to move.`;
  };

  return (
    <div style={{ 
      maxWidth: '1400px', 
      margin: '0 auto', 
      padding: '24px', 
      backgroundColor: 'white' 
    }}>
      <h1 style={{ 
        fontSize: '32px', 
        fontWeight: 'bold', 
        textAlign: 'center', 
        marginBottom: '32px', 
        color: '#374151' 
      }}>
        Three-Fold Counter
      </h1>
      
      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: '1fr 1fr', 
        gap: '32px' 
      }}>
        {/* Chessboard Section */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center' 
        }}>
          <div style={{ marginBottom: '16px' }}>
            <div style={{ 
              width: '100%', 
              maxWidth: '512px', 
              border: '2px solid #d1d5db', 
              borderRadius: '8px', 
              padding: '8px', 
              backgroundColor: 'white', 
              boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' 
            }}>
              <Chessboard
                position={game.fen()}
                onPieceDrop={onDrop}
                boardWidth={500}
                arePremovesAllowed={false}
                customBoardStyle={{
                  borderRadius: '4px',
                  boxShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
                }}
              />
            </div>
          </div>
          
          {/* Game Status */}
          <div style={{ textAlign: 'center', marginBottom: '16px' }}>
            <p style={{ 
              fontSize: '18px', 
              fontWeight: '600', 
              color: '#374151', 
              marginBottom: '16px' 
            }}>
              {gameStatus()}
            </p>
          </div>
          
          {/* Game Controls */}
          <div style={{ 
            display: 'flex', 
            gap: '16px', 
            justifyContent: 'center' 
          }}>
            <button
              onClick={undoMove}
              disabled={moveHistory.length === 0}
              style={{ 
                padding: '12px 24px', 
                backgroundColor: moveHistory.length === 0 ? '#d1d5db' : '#3b82f6', 
                color: 'white', 
                borderRadius: '8px', 
                border: 'none', 
                fontWeight: '600', 
                cursor: moveHistory.length === 0 ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                if (moveHistory.length > 0) {
                  e.target.style.backgroundColor = '#2563eb';
                }
              }}
              onMouseOut={(e) => {
                if (moveHistory.length > 0) {
                  e.target.style.backgroundColor = '#3b82f6';
                }
              }}
            >
              Undo Move
            </button>
            <button
              onClick={resetGame}
              style={{ 
                padding: '12px 24px', 
                backgroundColor: '#ef4444', 
                color: 'white', 
                borderRadius: '8px', 
                border: 'none', 
                fontWeight: '600', 
                cursor: 'pointer',
                transition: 'background-color 0.2s'
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = '#dc2626';
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = '#ef4444';
              }}
            >
              Reset Game
            </button>
          </div>
        </div>

        {/* Move History Section */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          border: '2px solid #d1d5db', 
          borderRadius: '8px', 
          backgroundColor: 'white', 
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)' 
        }}>
          <h2 style={{ 
            fontSize: '20px', 
            fontWeight: '600', 
            padding: '16px', 
            background: 'linear-gradient(to right, #f3f4f6, #e5e7eb)', 
            color: '#374151', 
            borderBottom: '2px solid #d1d5db', 
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
            margin: '0'
          }}>
            Move History
          </h2>
          <div style={{ flex: '1', overflow: 'hidden' }}>
            <div style={{ height: '384px', overflowY: 'auto' }}>
              <table style={{ width: '100%', fontSize: '14px', borderCollapse: 'collapse' }}>
                <thead style={{ 
                  background: 'linear-gradient(to right, #dbeafe, #bfdbfe)', 
                  position: 'sticky', 
                  top: '0' 
                }}>
                  <tr>
                    <th style={{ 
                      padding: '12px', 
                      textAlign: 'left', 
                      fontWeight: '600', 
                      color: '#374151', 
                      borderBottom: '1px solid #d1d5db', 
                      width: '80px' 
                    }}>
                      Move
                    </th>
                    <th style={{ 
                      padding: '12px', 
                      textAlign: 'left', 
                      fontWeight: '600', 
                      color: '#374151', 
                      borderBottom: '1px solid #d1d5db', 
                      width: '96px' 
                    }}>
                      SAN
                    </th>
                    <th style={{ 
                      padding: '12px', 
                      textAlign: 'left', 
                      fontWeight: '600', 
                      color: '#374151', 
                      borderBottom: '1px solid #d1d5db', 
                      width: '320px' 
                    }}>
                      Position (FEN)
                    </th>
                    <th style={{ 
                      padding: '12px', 
                      textAlign: 'center', 
                      fontWeight: '600', 
                      color: '#374151', 
                      borderBottom: '1px solid #d1d5db', 
                      width: '80px' 
                    }}>
                      Count
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {moveHistory.length === 0 ? (
                    <tr>
                      <td 
                        colSpan="4" 
                        style={{ 
                          padding: '48px 24px', 
                          textAlign: 'center', 
                          color: '#6b7280', 
                          fontStyle: 'italic' 
                        }}
                      >
                        No moves yet. Start playing by moving a piece!
                      </td>
                    </tr>
                  ) : (
                    [...moveHistory].reverse().map((move, reverseIndex) => {
                      const index = moveHistory.length - 1 - reverseIndex;
                      const duplicateCount = fenCounts[move.positionKey] || 1;
                      const isThreefold = duplicateCount >= 3;
                      
                      return (
                        <tr 
                          key={index} 
                          style={{ 
                            borderBottom: '1px solid #e5e7eb', 
                            transition: 'all 0.2s',
                            backgroundColor: isThreefold 
                              ? '#fef2f2' 
                              : reverseIndex % 2 === 0 
                                ? 'white' 
                                : '#f9fafb'
                          }}
                          onMouseOver={(e) => {
                            if (isThreefold) {
                              e.target.style.backgroundColor = '#fee2e2';
                            } else {
                              e.target.style.backgroundColor = '#eff6ff';
                            }
                          }}
                          onMouseOut={(e) => {
                            if (isThreefold) {
                              e.target.style.backgroundColor = '#fef2f2';
                            } else {
                              e.target.style.backgroundColor = reverseIndex % 2 === 0 ? 'white' : '#f9fafb';
                            }
                          }}
                        >
                          <td style={{ 
                            padding: '12px', 
                            fontWeight: '500', 
                            color: '#1f2937', 
                            borderRight: '1px solid #e5e7eb' 
                          }}>
                            <span style={{ display: 'inline-block', minWidth: '32px' }}>
                              {move.moveNumber}{move.isWhiteMove ? '.' : '...'}
                            </span>
                          </td>
                          <td style={{ 
                            padding: '12px', 
                            fontFamily: 'monospace', 
                            fontWeight: '600', 
                            color: '#1d4ed8', 
                            borderRight: '1px solid #e5e7eb' 
                          }}>
                            {move.san}
                          </td>
                          <td style={{ 
                            padding: '12px', 
                            fontFamily: 'monospace', 
                            fontSize: '12px', 
                            color: '#4b5563', 
                            borderRight: '1px solid #e5e7eb' 
                          }}>
                            <div style={{ 
                              maxWidth: '300px', 
                              overflow: 'hidden', 
                              textOverflow: 'ellipsis', 
                              whiteSpace: 'nowrap' 
                            }} title={move.fen}>
                              {move.fen}
                            </div>
                          </td>
                          <td style={{ padding: '12px', textAlign: 'center' }}>
                            <div style={{ 
                              display: 'inline-flex', 
                              alignItems: 'center', 
                              justifyContent: 'center', 
                              minWidth: '32px', 
                              height: '24px', 
                              padding: '0 8px', 
                              borderRadius: '9999px', 
                              fontSize: '12px', 
                              fontWeight: 'bold',
                              backgroundColor: isThreefold 
                                ? '#dc2626' 
                                : duplicateCount > 1
                                  ? '#fed7aa'
                                  : '#e5e7eb',
                              color: isThreefold 
                                ? 'white' 
                                : duplicateCount > 1
                                  ? '#9a3412'
                                  : '#374151'
                            }}>
                              {duplicateCount}
                            </div>
                            {isThreefold && (
                              <div style={{ 
                                fontSize: '12px', 
                                color: '#dc2626', 
                                fontWeight: '600', 
                                marginTop: '4px' 
                              }}>
                                THREEFOLD
                              </div>
                            )}
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChessGame;